import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListAdminPromotionTypesRequest, ListAdminPromotionTypesResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminPromotionTypeApi = createApi({
    reducerPath: "adminPromotionTypeApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listPromotionTypes: builder.query<ListAdminPromotionTypesResponse, ListAdminPromotionTypesRequest>({
            query: body => ({
                url: `promotiontype/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        })
    })
});

export const {
    useListPromotionTypesQuery,
    useLazyListPromotionTypesQuery
} = adminPromotionTypeApi;
